import { useEffect, useState } from "react";

import Spinner from "./SpinnerVideo";
import {
  fetchSpinner,
  fetchSpinnerItem,
  updateLimitItem,
} from "../services/SpinnerWheelService";
import { Box } from "@mui/material";

const SpinnerComponent = ({ handleRestart }) => {
  const [dataItem, setDataItem] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [BackData, setBackData] = useState([]);
  const [spinLoading, setSpinIsLoading] = useState(true);
  const [Loading, setLoading] = useState(false);
  const [question, setQuestion] = useState();

  const updateLimit = async (id, limit) => {
    try {
      setLoading(true);
      limit = limit - 1;
      const resultItem = await updateLimitItem({ id, limit });
      setDataItem((prev) => {
        const currentArr = [...prev];
        const index = currentArr.findIndex((arr) => arr.id === resultItem.id);
        currentArr[index] = resultItem;
        let filterResult = currentArr.filter((item) => item.limit > 0);
        setFilterData(filterResult);

        return currentArr;
      });

      setLoading(false);
    } catch (err) {
      setLoading(false);
      throw err;
    }
  };
  const fetchItem = async (id) => {
    try {
      setSpinIsLoading(true);
      const result = await fetchSpinner(id);
      const resultItem = await fetchSpinnerItem(id);
      const filterResult = await resultItem.filter((item) => item.limit > 0);
      setDataItem(resultItem);
      setBackData(result);
      setFilterData(filterResult);
      setSpinIsLoading(false);
    } catch (err) {
      setSpinIsLoading(false);
      throw err;
    }
  };

  useEffect(() => {
    fetchItem(23);
  }, []);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundImage: !question && `url(${BackData?.background})`, // Replace with your actual image path
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        bgcolor:  "#4b777c", // Fallback color if image doesn't load
        color: "white",
        textAlign: "center",
    
        minHeight: "100vh",
        width: "100%",
        height: 1,
        boxShadow: 4,
      }}
    >
      <Spinner
        updateLimit={updateLimit}
        dataItem={dataItem}
        filterData={filterData}
        BackData={BackData}
        spinLoading={spinLoading}
        Loading={Loading}
        handleRestart={handleRestart}
        question={question}
        setQuestion={setQuestion}
      />
    </Box>
  );
};

export default SpinnerComponent;
